import { useEffect, useState } from "react";

const utcFormatter = new Intl.DateTimeFormat(undefined, {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "numeric",
  minute: "2-digit",
  hour12: true,
  timeZone: "UTC"
});

export function formatUtcDateTime(value) {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return "Invalid date";
  }
  return utcFormatter.format(date);
}

export function formatCurrentUtcLine(value) {
  return `All times are UTC. Current UTC: ${formatUtcDateTime(value)}`;
}

export function useCurrentUtcTime() {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    let intervalId = 0;
    const syncToMinute = () => {
      setNow(new Date());
      intervalId = window.setInterval(() => {
        setNow(new Date());
      }, 60_000);
    };

    const current = new Date();
    const delay = (60 - current.getUTCSeconds()) * 1000 - current.getUTCMilliseconds();
    const timeoutId = window.setTimeout(syncToMinute, Math.max(delay, 0));

    return () => {
      window.clearTimeout(timeoutId);
      if (intervalId) {
        window.clearInterval(intervalId);
      }
    };
  }, []);

  return now;
}
